// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fade-enter-active[data-v-553d3d7e],.fade-leave-active[data-v-553d3d7e]{transition:all .4s ease-in-out}.fade-enter[data-v-553d3d7e],.fade-leave-to[data-v-553d3d7e]{opacity:.4}", ""]);
// Exports
module.exports = exports;
